import { render, staticRenderFns } from "./RenderText.vue?vue&type=template&id=4ad37286&scoped=true&"
import script from "./RenderText.vue?vue&type=script&lang=js&"
export * from "./RenderText.vue?vue&type=script&lang=js&"
import style0 from "./RenderText.vue?vue&type=style&index=0&id=4ad37286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad37286",
  null
  
)

export default component.exports